import { render, staticRenderFns } from "./LawText.vue?vue&type=template&id=85094756&scoped=true&"
import script from "./LawText.vue?vue&type=script&lang=js&"
export * from "./LawText.vue?vue&type=script&lang=js&"
import style0 from "./LawText.vue?vue&type=style&index=0&id=85094756&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85094756",
  null
  
)

export default component.exports